import { useRef, useState } from 'react';

export const useDialog = <T extends HTMLElement>() => {
  const ref = useRef<T | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handleToggle = () => setIsOpen(open => !open);

  return { ref, isOpen, handleOpen, handleClose, handleToggle };
};
